import {IconProps} from '../icon-props-interface';
import '../icons.scss';

const IconCircleRight = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 9C0 13.9711 4.02891 18 9 18C13.9711 18 18 13.9711 18 9C18 4.02891 13.9711 0 9 0C4.02891 0 0 4.02891 0 9ZM8.47266 13.2539C8.14219 13.5844 7.60781 13.5844 7.28086 13.2539C6.95391 12.9234 6.95039 12.3891 7.28086 12.0621L10.3395 9.00352L7.28086 5.94492C6.95039 5.61445 6.95039 5.08008 7.28086 4.75312C7.61133 4.42617 8.1457 4.42266 8.47266 4.75312L12.1289 8.40234C12.4594 8.73281 12.4594 9.26719 12.1289 9.59414L8.47266 13.2539Z"
      fill={color}/>
</svg>

    </div>
);

export default IconCircleRight;
